export default __webpack_public_path__ + "static/media/click.3db7a772.jpg";